/*jslint node: true, browser: true, unparam: true*/

"use strict";

var $ = require("pli/jquery");
var ko = require("pli/knockout");
var pli = require("pli/forms");

//-------------------------------------------
function Upload(element, valueAccessor, isDisabled, multiple) {
    this.dataType = "json";
    this.dragoverClass = "in";
    this.valueAccessor = valueAccessor;
    this.isDisabled = isDisabled;
    this.url = pli.resolveUrl('~/Upload');
    this.$element = $(element);
    this.$container = this.$element.closest("li");
    this.dropZone = this.$dropZone = this.$container.closest(".dropZone");
    this.$dragMessage = this.$dropZone.find(".dragMessage");
    this.multiple = multiple;
    this.fileInput = this.$file = $("<input type=\"file\" name=\"files[]\"" + (this.multiple ? " multiple=\"multiple\"" : "") + " />");

    this._clearDragover = this._clearDragover.bind(this);
    this.add = this.add.bind(this);
    this.done = this.done.bind(this);
    this.dragover = this.dragover.bind(this);
    this.fail = this.fail.bind(this);
    this.progress = this.progress.bind(this);
}


//-------------------------------------------
Upload.prototype.add = function addUpload(e, data) {
    /// <summary>
    /// Calls attachFiles on the grid view models and
    /// automatically starts uploading files.
    /// </summary>
    var value = this.valueAccessor();
    if (!value || typeof value.attachFiles !== "function") {
        throw new Error("geoUploadButton valueAccessor requires attachFiles function");
    }
    data.context = value.attachFiles(data.files); // store attached files update in (done, fail, progress) handlers
    data.submit();
};


//-------------------------------------------
Upload.prototype.done = function uploadDone(e, data) {
    /// <summary>
    /// Updates the state of uploaded files to done.
    /// Includes the id used to identify the uploaded
    /// file.
    /// </summary>
    var i, l, f;
    for (i = 0, l = data.context.length; i < l; i += 1) {
        f = data.context[i];
        f.updateAttachedFile("done", data.result && data.result[i]);
    }
};


//-------------------------------------------
Upload.prototype.dragover = function uploadDragover() {
    /// <summary>
    /// The dragover event is contiuously triggered while
    /// dragging a file over the dropzone.  This method ensures
    /// the dragoverClass is added/removed on the dropZone.
    /// </summary>
    if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
    } else {
        this.$dropZone.addClass(this.dragoverClass);
        if (this.$dragMessage) {
            this.$dragMessage.offset({ top: this.$dropZone.offset().top });
            this.$dragMessage.outerHeight(this.$dropZone.outerHeight());
        }
    }
    this.timeout = setTimeout(this._clearDragover, 100);
};


//-------------------------------------------
Upload.prototype.fail = function uploadFail(e, data) {
    /// <summary>
    /// Updates the state of uploaded files to fail
    /// </summary>
    var i, l, f;
    for (i = 0, l = data.context.length; i < l; i += 1) {
        f = data.context[i];
        f.updateAttachedFile("fail", "Upload failed. Please try again.");
    }
};


//-------------------------------------------
Upload.prototype.progress = function uploadProgress(e, data) {
    /// <summary>
    /// Updates the progress of uploaded files.
    /// </summary>
    var i, l, f, p = parseInt(data.loaded / data.total * 100, 10);
    for (i = 0, l = data.context.length; i < l; i += 1) {
        f = data.context[i];
        f.updateAttachedFile("busy", p);
    }
};


//-------------------------------------------
Upload.prototype._clearDragover = function uploadClearDragover() {
    /// <summary>
    /// Removes dragoverClass from dropzone when
    /// no longer dragging file.
    /// </summary>
    this.$dropZone.removeClass(this.dragoverClass);
    this.timeout = null;
};


//-------------------------------------------
Upload.prototype._destroy = function destroyUpload() {
    this.$element("destroy");
    this.$container.remove(this.$file);
    if (this.isDisabledSubscription && typeof this.isDisabledSubscription.dispose === "function") {
        this.isDisabledSubscription.dispose();
    }
};


//-------------------------------------------
Upload.prototype._init = function initUpload() {
    this.$container.append(this.$file);
    this.$element.fileupload(this);
    if (ko.isObservable(this.isDisabled)) {
        this.isDisabledSubscription = this.isDisabled.subscribe(this._updateState, this);
        this._updateState(this.isDisabled());
    }
};


//-------------------------------------------
Upload.prototype._updateState = function updateUploadState(value) {
    this.$element.fileupload(value === true ? "disable" : "enable");
};


//-------------------------------------------
ko.bindingHandlers.geoUploadButton = {
    init: function geoUploadButton(element, valueAccessor, allBindingsAccessor) {
        var upload = new Upload(element, valueAccessor, allBindingsAccessor().geoUploadButtonDisabled, allBindingsAccessor().multiple);
        upload._init();
    }
};

// prevent default file drag and drop (only allow over drop zone)
$(document).on('drop dragover', function preventDefaultDrop(e) {
    e.preventDefault();
    return false;
});




//////////////////
// WEBPACK FOOTER
// ./app/filestore/fileStoreUpload.js
// module id = 506
// module chunks = 49